import { PAGE_SIZE } from '../const';
import { page } from './page';

interface Config {
  row_index: number;
  size?: number;
}

// row_index 가 18n+3 수열의 원소일 경우 광고 구좌 (2n 번 페이지 3번 구좌)
export const isBarAutoAdBannerSlot = ({ row_index, size = PAGE_SIZE / 2 }: Config) =>
  page({ index: row_index, size }) % 2 === 0 && row_index % size === 3;
